import {createStyles} from '@material-ui/core';
import {defaultFont, lightGrayColor, primaryColor, secondaryColor} from '../../styles/style';

const style = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    maxWidth: '500px',
  },
  container__actions: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0 12px 12px',
  },
  installQRsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: '16px',
  },
  installQRsContainer__qr: {
    height: '180px',
    width: '180px',
  },
  installQRsContainer__showButton_link: {
    ...defaultFont,
    background: 'none!important',
    border: 'none',
    padding: '0!important',
    color: secondaryColor,
    textDecoration: 'underline',
    cursor: 'pointer',
    display: 'contents',
    fontSize: '14px',
  },
  installQRsContainer__column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
  secretDisplay: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },
  secretDisplay__qrContainer: {
    height: '200px',
    width: '200px',
    marginTop: '8px',
    marginLeft: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  secretDisplay__manualKeyEntering: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  manualKeyEntering__secretText: {
    ...defaultFont,
    margin: 0,
    padding: '8px 12px',
    borderRadius: '4px',
    backgroundColor: lightGrayColor,
  },
  recoveryCode__row: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    margin: '20px 0 16px',
  },
  title: {
    ...defaultFont,
    fontSize: '18px',
    fontWeight: 'bold',
    marginTop: 0,
  },
  warningText: {
    ...defaultFont,
    fontWeight: 'bold',
  },
  input_noArrows: {
    '& input[type=number]': {
      // For Chrome, Safari, Edge, Opera
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        'margin': 0,
      },
      // For Firefox
      '-moz-appearance': 'textfield',
    },
  },
  checkbox__label: {
    ...defaultFont,
    color: primaryColor,
    paddingTop: '2px',
  },
});

export default style;
